export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const SIGNUP_REQUEST = "SIGN_REQUEST";
export const SIGNUP_SUCCESS = "SIGN_SUCCESS";
export const SIGNUP_FAILURE = "SIGN_FAILURE";
